// extracted by mini-css-extract-plugin
export var wrapper = "BlogPreview-module--wrapper--1QjpO";
export var thumbnail = "BlogPreview-module--thumbnail--1Nyzm";
export var image = "BlogPreview-module--image--2VFyD";
export var header = "BlogPreview-module--header--eElk_";
export var date = "BlogPreview-module--date--3Q7Ym";
export var description = "BlogPreview-module--description--37QN3";
export var more = "BlogPreview-module--more--2i8Tq";
export var moreLink = "BlogPreview-module--moreLink--3SkmL";
export var details = "BlogPreview-module--details--1Q4Na";